import React, { Component, PropTypes } from 'react';
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import 'react-select/dist/react-select.css';
import { uniqBy, sortBy, includes, find } from 'lodash';
import * as actions from 'state/modules/assign';
import translate from 'i18n/translate';
import { VirtualizedSelect } from 'containers';
import { Button } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import styles from './AdminScreen.css';

let divisionMappedToValue = [];
const divisionCode = (marketDirectorList) => {
  const divCode = sortBy(marketDirectorList.data, 'cica_divisioncode', 'cica_marketcode');
  divisionMappedToValue =
      uniqBy(divCode.map(obj => (
        {
          value: obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`,
          label: obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`,
          id: obj.systemuserid,
          emailId: obj.internalemailaddress,
          ownerGuid: obj.systemuserid,
          marketCode: obj.cica_marketcode,
          openId: obj.cica_openmdname
        }
      )), 'value');
  return (
    uniqBy(divCode.map(obj => (
      {
        value: obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`,
        label: obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`,
      }
    )), 'value')
  );
};
let idMappingToValue = [];
class AdminScreen extends Component {
  static propTypes = {
    dropdownAgents: PropTypes.func,
    marketDirectorList: PropTypes.arrayOf(PropTypes.shape({})),
    setOwnerId: PropTypes.func,
    strings: React.PropTypes.shape({}),
    // ivCode: PropTypes.number,
    currentLanguage: PropTypes.strings,
    ownerId: PropTypes.strings
  }

  state = {
    secondaryMarket: [],
    primaryMarket: [],
    code: true,
    market: true,
    continue: true,
    value: 'No',
    label: '',
    isAdminScreen: true,
  }

  componentDidMount() {
    this.props.dropdownAgents(this.props.ownerId);
  }
  getContinueDisabled = () => {
    let disabledStatus = true;
    disabledStatus = this.state.primaryMarket.length === 0;
    if (this.state.primaryMarket.length > 0 &&
      this.state.value === 'Yes' &&
      this.state.secondaryMarket.length === 0) {
      disabledStatus = true;
    }
    return disabledStatus;
  }
  codelist = (marketDirectorList) => {
    const marketData = sortBy(marketDirectorList.data, 'cica_divisioncode', 'cica_marketcode');
    const hasSelectedMaxCount = this.state.secondaryMarket.length > 1;
    idMappingToValue =
      uniqBy(marketData.map(obj => (
        { value: obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`,
          label: obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`,
          id1: obj.systemuserid,
          emailId1: obj.internalemailaddress,
          ownerGuid1: obj.systemuserid,
          clearableValue: false,
          marketCoded: obj.cica_marketcode,
          openId: obj.cica_openmdname,
          disable: hasSelectedMaxCount && !includes(this.state.secondaryMarket, obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`)
        }
      )), 'value');
    return (
      uniqBy(marketData.map(obj => (
        { value: obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`,
          label: obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`,
          clearableValue: false,
          disable: hasSelectedMaxCount && !includes(this.state.secondaryMarket, obj.cica_openmdname === null ? `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.fullname}` : `${obj.cica_divisioncode} - ${obj.cica_marketcode} ${obj.cica_openmdname}`)
        }
      )), 'value')
    );
  };

  handleChange = (value) => {
    if (value) {
      this.setState({ value });
      this.setState({ market: false });
      this.setState({ secondaryMarket: [] });
      if (value === 'No') {
        this.setState({ market: true });
      }
    } else {
      this.setState({ value: 'No' });
      this.setState({ market: true });
      this.setState({ secondaryMarket: [] });
    }
  };

  selectPrimaryMarket = (key, value) => {
    this.handleChange('No');
    let primaryMarket;
    const request = new Promise((resolve) => {
      primaryMarket = value && value.length ? value.map(item => item.label) : [];
      this.setState({ primaryMarket });
      resolve(primaryMarket);
    });
    return request;
  };

  selectAnotherMarket = (key, value) => {
    let secondaryMarket;
    const request = new Promise((resolve) => {
      secondaryMarket = value && value.length ? value.map(item => item.label) : [];
      this.setState({ secondaryMarket });
      resolve(secondaryMarket);
    });
    return request;
  };

  moveToAssign = (evt) => {
    evt.preventDefault();
    const selectedSecondMarketValues = idMappingToValue.filter(mappingValue => (
      find(this.state.secondaryMarket, selectedValue => selectedValue === mappingValue.value)
    ));
    const secondMarketId = selectedSecondMarketValues.map(value => value.emailId1);
    const secondMarketGuid = selectedSecondMarketValues.ownerGuid;


    const primaryMarketLabel = this.state.primaryMarket[0];
    const selectedPrimaryMarketValue =
      find(divisionMappedToValue, mappingValue => primaryMarketLabel === mappingValue.value);
    const primaryMarketId = selectedPrimaryMarketValue.emailId;
    const primaryMarketGuid = selectedPrimaryMarketValue.ownerGuid;
    const marketCode = selectedPrimaryMarketValue.marketCode;
    const marketOpen = selectedPrimaryMarketValue.openId;

    this.props.setOwnerId(primaryMarketId, primaryMarketGuid,
      secondMarketId, secondMarketGuid, this.state.label,
      marketOpen, marketCode, selectedSecondMarketValues);
    this.context.router.push('/');
  }

  render() {
    const { strings } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <span className={styles.marketHeader}>
            {strings.assignques}
          </span>
          <div className={styles.naming}>
            {strings.selectDivision}
          </div>
          <div className={styles.mainDiv}>
            <VirtualizedSelect
              className={styles.inputDiv}
              labelKey="label"
              options={divisionCode(this.props.marketDirectorList)}
              valueKey="value"
              isAdminScreen={this.state.isAdminScreen}
              type={this.state.value}
              updateFilter={this.selectPrimaryMarket}
              placeholder={strings.selectdiv}
              hintText={strings.searchText}
              filterValues={this.state.primaryMarket}
              currentLanguage={this.props.currentLanguage}
              singleSelect
            />
          </div>
        </div>
        <div className={styles.innerContainer}>
          <div className={styles.naming}>
            {strings.leadsquesn}
          </div>
          <div>
            <RadioGroup
              name="select"
              value={this.state.value}
              onChange={this.handleChange}
              disabled={this.state.primaryMarket.length === 0}
              theme={styles}
              className={styles.radioHolder}
            >
              <RadioButton
                label={strings.no}
                value="No"
                theme={styles}
              />
              <RadioButton
                label={strings.yes}
                value="Yes"
                theme={styles}
              />
            </RadioGroup>
          </div>
        </div>
        {!this.state.market && <div className={styles.innerContainer}>
          <div className={styles.naming}>
            <span className={styles.naming}>{strings.selectDivision}</span>
            <span className={styles.maxLabel}>{strings.max2}</span>
          </div>
          <div className={styles.mainDiv}>
            <VirtualizedSelect
              className={styles.inputDiv}
              labelKey="label"
              options={this.codelist(this.props.marketDirectorList)}
              valueKey="value"
              type={this.state.value}
              updateFilter={this.selectAnotherMarket}
              placeholder={strings.selectdiv}
              isAdminScreen={this.state.isAdminScreen}
              hintText={strings.searchText}
              filterValues={this.state.secondaryMarket}
              disabled={this.state.market}
              currentLanguage={this.props.currentLanguage}
              SelectMultiValueWrapperWidth={'30em'}
            />
          </div>
        </div>}
        <Button
          raised
          theme={styles}
          disabled={this.getContinueDisabled()}
          onClick={this.moveToAssign}
        >
          {strings.continue}
        </Button>
      </div>
    );
  }
}

AdminScreen.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  marketDirectorList: state.assign.marketDirectorList,
  currentLanguage: state.assign && state.assign.currentLanguage,
  ownerId: state.assign.ownerId
});

const AdminScreenString = translate('AdminScreen')(AdminScreen);

export default connect(mapStateToProps, actions)(AdminScreenString);



// WEBPACK FOOTER //
// ./src/components/AdminScreen/AdminScreen.js